/**
 * RoCo homepage app defer (Phase 1 + Rank 1/2 trim 2026-09-23; Rebuy cart fix 2026-10-07;
 * Rebuy on first interaction 2026-10-08, ROCO-PERF).
 * Homepage only (`/` path).
 * - Rebuy: release on the visitor's first interaction (scroll, touch, pointer, key, wheel)
 *   so Smart Cart is ready before most cart clicks without adding Rebuy's CPU work to the
 *   initial load. An early cart click is still held, Rebuy is released, then Smart Cart opens.
 * - Marsello: release on cart / loyalty / rewards / account click only.
 * - ReCharge SF / widget: never load on homepage (PDP / non-index stay eager).
 * - Soft (FB / Klaviyo / WSG): still idle / timeout fail-open so they eventually boot.
 * - Once a group is released, its follow-up script inserts are no longer intercepted.
 * - No subscribe-view IntersectionObserver (nav / newsletter Subscribe false positives).
 * Fail-open: errors leave normal loading alone.
 */
(function () {
  'use strict';
  try {
    if (window.__rocoHpDefer) return;
    window.__rocoHpDefer = true;
    window.__rocoHpDeferVer = '2026-10-08-r14';

    var path = location.pathname || '/';
    if (path !== '/' && path !== '') return;

    var BLOCK = /marsello\.app|rechargecdn\.com|storefront-experiences|rebuyengine\.com|klaviyo\.com\/onsite|static\.klaviyo\.com|fbevents\.js|connect\.facebook\.net\/en_US\/fbevents|wsg-dependencies|wholesale-gorilla/i;
    var RECHARGE = /rechargecdn|storefront-experiences/i;
    var MARSELLO = /marsello\.app/i;
    var REBUY = /rebuyengine\.com/i;
    var SOFT = /klaviyo\.com\/onsite|static\.klaviyo\.com|fbevents\.js|connect\.facebook\.net\/en_US\/fbevents|wsg-dependencies|wholesale-gorilla/i;

    // Elements that open the cart drawer (header icon, mobile header button, cart links).
    var CART_OPENER = '[aria-controls="site-cart-sidebar"], .button--cart-handle, .mobile-cart-button, a[href="/cart"], a[href$="/cart"]';

    var released = { marsello: false, rebuy: false, soft: false };
    var queue = [];
    var idleMs = 5500;

    function flushQueue(items, why) {
      window.__rocoHpDeferWhy = why;
      for (var i = 0; i < items.length; i++) {
        try { items[i](); } catch (e) {}
      }
    }

    function takeMatching(testFn) {
      var keep = [];
      var run = [];
      for (var i = 0; i < queue.length; i++) {
        var fn = queue[i];
        var src = fn.__rocoSrc || '';
        if (testFn(src)) run.push(fn);
        else keep.push(fn);
      }
      queue = keep;
      return run;
    }

    function releaseGroup(key, re, why) {
      released[key] = true;
      var run = takeMatching(function (src) { return re.test(src); });
      if (run.length) flushQueue(run, why);
    }

    function releaseMarsello(why) { releaseGroup('marsello', MARSELLO, why); }
    function releaseRebuy(why) { releaseGroup('rebuy', REBUY, why); }
    function releaseSoft(why) { releaseGroup('soft', SOFT, why); }

    function shouldBlock(src) {
      src = String(src || '');
      if (!src || !BLOCK.test(src)) return false;
      // Already-released groups load normally (their own follow-up scripts included).
      if (released.rebuy && REBUY.test(src)) return false;
      if (released.marsello && MARSELLO.test(src)) return false;
      if (released.soft && SOFT.test(src)) return false;
      return true;
    }

    function enqueueSrc(src, attrs) {
      var fn = function () {
        var s = document.createElement('script');
        if (attrs) {
          for (var k in attrs) {
            if (Object.prototype.hasOwnProperty.call(attrs, k) && attrs[k] != null) {
              s.setAttribute(k, attrs[k]);
            }
          }
        }
        if (!attrs || !attrs.type) s.async = true;
        s.src = src;
        (document.head || document.documentElement).appendChild(s);
      };
      fn.__rocoSrc = String(src || '');
      queue.push(fn);
    }

    function wrapInsert(orig) {
      return function (node) {
        try {
          if (node && node.tagName === 'SCRIPT') {
            var src = node.src || node.getAttribute('src') || '';
            if (shouldBlock(src)) {
              // Drop ReCharge inserts on homepage entirely (never enqueue).
              if (RECHARGE.test(src)) {
                window.__rocoHpDeferDroppedRecharge = (window.__rocoHpDeferDroppedRecharge || 0) + 1;
                return node;
              }
              var attrs = {};
              if (node.type) attrs.type = node.type;
              if (node.id) attrs.id = node.id;
              enqueueSrc(src, attrs);
              return node;
            }
          }
        } catch (e) {}
        return orig.apply(this, arguments);
      };
    }

    if (Element.prototype.appendChild) {
      Element.prototype.appendChild = wrapInsert(Element.prototype.appendChild);
    }
    if (Element.prototype.insertBefore) {
      Element.prototype.insertBefore = wrapInsert(Element.prototype.insertBefore);
    }

    function sweepExisting() {
      var scripts = document.querySelectorAll('script[src]');
      for (var i = 0; i < scripts.length; i++) {
        var el = scripts[i];
        var src = el.src || '';
        if (!shouldBlock(src)) continue;
        if (RECHARGE.test(src)) {
          el.remove();
          window.__rocoHpDeferDroppedRecharge = (window.__rocoHpDeferDroppedRecharge || 0) + 1;
          continue;
        }
        var attrs = {};
        if (el.type) attrs.type = el.type;
        if (el.id) attrs.id = el.id;
        enqueueSrc(src, attrs);
        el.remove();
      }
    }

    function smartCartReady() {
      var sc = window.Rebuy && window.Rebuy.SmartCart;
      return !!(sc && typeof sc.show === 'function');
    }

    // Early cart click: hold the theme drawer, load Rebuy, open Smart Cart.
    // Fallback after 6s: let the theme drawer open so the click is never lost.
    var waitingForCart = false;
    function openSmartCartWhenReady(opener) {
      if (waitingForCart) return;
      waitingForCart = true;
      var started = Date.now();
      (function poll() {
        if (smartCartReady()) {
          waitingForCart = false;
          window.__rocoHpDeferCartOpen = 'smart-cart';
          try { window.Rebuy.SmartCart.show(); } catch (e) {}
          return;
        }
        if (Date.now() - started > 6000) {
          waitingForCart = false;
          window.__rocoHpDeferCartOpen = 'theme-fallback';
          try { opener.__rocoPassThrough = true; opener.click(); } catch (e) {}
          return;
        }
        setTimeout(poll, 100);
      })();
    }

    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;

      var opener = t.closest(CART_OPENER);
      if (opener) {
        if (opener.__rocoPassThrough) { opener.__rocoPassThrough = false; return; }
        releaseRebuy('click-cart');
        releaseMarsello('click-cart');
        releaseSoft('click-soft');
        if (!smartCartReady()) {
          e.preventDefault();
          e.stopImmediatePropagation();
          openSmartCartWhenReady(opener);
        }
        return;
      }

      var hit = t.closest('a,button,[role="button"],summary');
      if (!hit) return;
      var href = (hit.getAttribute('href') || '').toLowerCase();
      var blob = (
        href + ' ' +
        (hit.textContent || '') + ' ' +
        (hit.className || '') + ' ' +
        (hit.getAttribute('aria-label') || '')
      ).toLowerCase();

      // Add-to-cart / loyalty / account intent: Marsello + Rebuy (+ soft). Never ReCharge on /.
      if (/cart|bag|basket|reward|loyalty|marsello|account|#cart|\/cart/.test(blob)) {
        releaseRebuy('click-mars-rebuy');
        releaseMarsello('click-mars-rebuy');
        releaseSoft('click-soft');
        return;
      }
    }, true);

    function onReady(fn) {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', fn);
      } else {
        fn();
      }
    }

    onReady(function () {
      sweepExisting();
    });
    window.addEventListener('load', function () {
      sweepExisting();
    });

    // Soft apps: idle + hard timeout. Rebuy: first interaction (below). Marsello stays off until intent;
    // ReCharge never loads on homepage.
    function scheduleIdle() {
      var run = function () {
        setTimeout(function () {
          releaseSoft('idle-soft');
        }, idleMs);
      };
      if ('requestIdleCallback' in window) {
        requestIdleCallback(function () { run(); }, { timeout: 5000 });
      } else {
        window.addEventListener('load', run);
      }
    }
    scheduleIdle();
    setTimeout(function () {
      releaseSoft('timeout-soft');
    }, 8000);

    // Rebuy: first real interaction (2026-10-08). Lab tests never interact, so Rebuy's
    // CPU work stays out of the measured load; shoppers get it as soon as they scroll or tap.
    var INTERACT = ['scroll', 'wheel', 'touchstart', 'pointerdown', 'keydown'];
    function onFirstInteract() {
      for (var i = 0; i < INTERACT.length; i++) {
        window.removeEventListener(INTERACT[i], onFirstInteract, true);
      }
      releaseRebuy('interact-rebuy');
    }
    for (var j = 0; j < INTERACT.length; j++) {
      window.addEventListener(INTERACT[j], onFirstInteract, { capture: true, passive: true });
    }

    // Rank 2: do NOT pre-enqueue storefront-experiences.js on homepage.
  } catch (e) {
    /* fail open */
  }
})();
